import { getDeviceId, setStepRegister } from '@/auth'
import request from '@/request'
import CONSTANTS from '@/constants'

const state = {
    token: null,
    deviceId: getDeviceId(),
}
const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_DEVICE_ID: (state, id) => {
        state.deviceId = id
    },

}
const actions = {
    doRegister({ commit }, data) {
        return new Promise((resolve, reject) => {
            request({
                url: 'register/index',
                method: 'post',
                data: data
            }).then(response => {
                    // Set cookie
                let data = response.data;

                data.expire_day = CONSTANTS.COOKIE_EXPIRE_DAY;
                this.dispatch('login/setLoginCookie', data)
                setStepRegister(CONSTANTS.STEP_REGISTER_UPDATE_INFO)
                resolve(response.data)
            }).catch(error => {
                // if (error.response.data != undefined) {
                //     alert(error.response.data.message);
                // }
                reject(error)
            })
        })
    },


    verifySMSCode({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/register/verifySMSCode',
                method: 'get',
                params
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getSMSCode({ commit }, params) {
        return new Promise((resolve, reject) => {
            request({
                url: '/register/getSMSCode',
                method: 'get',
                params
            }).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}